/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";
import MediaPrepTable, { Column } from "../../../../common/commonComponents/lotDetailsTableMediaPrep";

interface LotDetailsProps {
  lotList: any[];
  onViewBatchDetails?: (batchId: string) => void;
  onViewLotUsage?: (lotId: string) => void;
  t: (key: string) => string;
}

const LotDetails: React.FC<LotDetailsProps> = ({ lotList, onViewBatchDetails, onViewLotUsage, t }) => {
const columns: Column[] = [
    {
      header: t('mediaPowder.lotDetails.lotTable.lotName'),
      render: (lot) => (
        <span className="font-black text-slate-800">{lot.lot_code || "-"}</span>
      )
    },
    {
      header: t('mediaPowder.lotDetails.lotTable.openingDate'),
      render: (lot) => (
        <span className="text-slate-500">
          {lot.opened_date !== t('mediaPowder.lotDetails.lotTable.notOpened')
            ? lot.opened_date
            : t('mediaPowder.lotDetails.notOpened')}
        </span>
      )
    },
    {
      header: t('mediaPowder.lotDetails.lotTable.available'),
      render: (lot) => (
        <span className="font-bold text-slate-700">{lot.available_stock || "-"}</span>
      )
    },
    {
      header: t('mediaPowder.lotDetails.lotTable.balance'),
      render: (lot) => (
        <span className="font-black text-emerald-600">{lot.available_stock || "-"}</span>
      )
    },
    {
      header: t('mediaPowder.lotDetails.lotTable.action'),
      className: "px-6 items-start",
      render: (lot) => (
        <div className="flex items-center justify-left gap-2">
          <button 
            onClick={() => onViewLotUsage?.(lot.id)}
            className="flex items-center gap-2 px-4 py-1.5 bg-orange-50 text-orange-600 rounded-lg font-black text-[9px] uppercase tracking-widest hover:bg-orange-600 hover:text-white transition-all shadow-sm"
          >
            <span className="material-symbols-outlined text-sm">
              {t('mediaPowder.icons.visibility')}
            </span>
            {t('mediaPowder.lotDetails.lotTable.view')}
          </button>
        </div>
      )
    }
  ];  
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
          <div className="px-3 py-3 border-b border-slate-100 bg-slate-50/30 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="material-symbols-outlined text-orange-500 font-black">{t('mediaPowder.icons.history')}</span>
              <h3 className="text-xs font-black text-slate-800 uppercase tracking-widest">{t('mediaPowder.lotDetails.lotTable.title')}</h3>
            </div>
          </div>
          <div className="overflow-x-auto">
          <MediaPrepTable
            columns={columns}
            data={lotList}
            emptyMessage={t('mediaPowder.lotDetails.lotTable.noLotData')}
          />
          </div>
        </div>
  );
};

export default LotDetails;